export { StickyFooter } from './StickyFooter';
export type { StickyFooterProps } from './StickyFooter.types';
